import _ from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  updateStudyProperty,
  clearStudyPropertyErrors,
  clearStudyPropertyAction
} from "actions/studies/studyPropertyActions";

import CustomPropertyForm from "components/common/properties/CustomPropertyForm";

const StudyPropertyUpdate = ({
  formId,
  params,
  setParams,
  closeModal,
  selected
}) => {
  const { lastAction, propertyErrors } = useSelector(
    state => state.studyProperties
  );
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearStudyPropertyAction());
      dispatch(clearStudyPropertyErrors());
    };
  }, [dispatch]);

  useEffect(() => {
    if (_.isEmpty(params)) {
      setParams({
        required: selected.required || false
      });
    }
  }, [params, setParams, selected]);

  // watch for success
  useEffect(() => {
    if (lastAction === "edit") {
      closeModal();
    }
  }, [lastAction, closeModal]);

  const handleSubmit = e => {
    e.preventDefault();
    const updatedParams = _.mapValues(params, (prop, key) => {
      const propValue = prop !== "" && prop !== null;
      const newValue = selected[key] !== prop;
      if (newValue && propValue) return prop;
    });
    updatedParams.id = selected.id;

    const updatedProperty = _.mergeWith(selected, updatedParams);
    dispatch(updateStudyProperty(updatedParams, updatedProperty));
  };

  if (_.size(params)) {
    return (
      <form
        id={formId}
        onSubmit={e => handleSubmit(e)}
        className="form container"
        noValidate
      >
        <CustomPropertyForm
          params={params}
          setParams={setParams}
          errors={propertyErrors}
        />
      </form>
    );
  }

  return "";
};

export default StudyPropertyUpdate;
